import * as React from 'react';
import type { Theme } from '@mui/material';
import { Typography } from '@mui/material';
import type { SxProps } from '@mui/system';

interface Props {
  content: string | undefined;
  startIcon?: React.ReactNode;
  dataCy?: string;
  inline?: boolean;
  type?: 'body1' | 'body2' | 'body3' | 'body4' | 'table-header';
  sx?: SxProps<Theme>;
  textOverflow?: 'ellipsis' | 'clip' | 'unset';
}

export const Text: React.FC<Props> = (props) => {
  const component = props.inline ? 'span' : 'div';
  // material ui doesn't have a body3 variant so we add one to match designs
  const variant =
    props.type && props.type !== 'body3' && props.type !== 'body4' && props.type !== 'table-header'
      ? props.type
      : 'body1';
  const overflow = props.textOverflow ? 'hidden' : 'unset';
  let sx = {};
  switch (props.type) {
    case 'body3':
      sx = {
        fontFamily: 'Lato',
        fontStyle: 'normal',
        fontWeight: 'normal',
        fontSize: '13px',
        lineHeight: '140%'
      };
      break;
    case 'body4':
      sx = {
        fontFamily: 'Lato',
        fontStyle: 'normal',
        fontWeight: 'normal',
        fontSize: '10px',
        lineHeight: '140%'
      };
      break;
    case 'table-header':
      sx = {
        fontFamily: 'Lato',
        fontStyle: 'normal',
        fontWeight: '700',
        fontSize: '14px',
        lineHeight: '16px'
      };
      break;
  }

  return (
    <Typography
      component={component}
      data-cy={props.dataCy}
      variant={variant}
      overflow={overflow}
      sx={{ ...sx, ...props.sx }}
    >
      <span>{props.startIcon ? props.startIcon : null}</span>
      {props.content}
    </Typography>
  );
};
